// Shared store-integrations query (list + row mapping).
//
// Extracted from RealStoreIntegrations so every consumer of the
// ['store-integrations'] react-query key (the Store Integrations settings
// section AND the Settings overlay header) shares ONE queryFn + row shape.
// Mixing different queryFns under the same key is a cache-shape footgun —
// keep this module the single source.

import { API_BASE } from '../../../lib/api'

export const STORE_INTEGRATIONS_QUERY_KEY = ['store-integrations'] as const

export type StoreRow = {
  id: string
  provider: string
  external_shop_id: string
  shop_name: string
  seller_org_id?: string
  org_id?: string
  org_name?: string
  sync_status?: string
  mockData?: boolean
  has_access_token?: boolean
  token_expires_at?: string | null
  last_sync_at?: string | null
  active?: boolean
  order_backfill_window?: string
  order_intake_enabled?: boolean
  /** Direct-from-Turkey store (mig 337): PEXIFY records its orders, never fulfils them. */
  direct_from_turkey?: boolean
}

type StoreApiRow = Partial<StoreRow> & {
  id: string
  name?: string
  platform?: string
  platform_store_id?: string
  is_active?: boolean
}

function mapStoreRow(store: StoreApiRow): StoreRow {
  return {
    id: store.id,
    provider: store.provider ?? store.platform ?? '',
    external_shop_id: store.external_shop_id ?? store.platform_store_id ?? '',
    shop_name: store.shop_name ?? store.name ?? 'Connected store',
    seller_org_id: store.seller_org_id,
    org_id: store.org_id ?? store.seller_org_id,
    org_name: store.org_name,
    sync_status: store.sync_status,
    mockData: Boolean(store.platform),
    has_access_token: store.has_access_token ?? store.is_active ?? false,
    token_expires_at: store.token_expires_at ?? null,
    last_sync_at: store.last_sync_at ?? null,
    active: store.active ?? store.is_active ?? false,
    order_backfill_window: store.order_backfill_window,
    order_intake_enabled: store.order_intake_enabled ?? store.is_active ?? false,
    direct_from_turkey: store.direct_from_turkey ?? false,
  }
}

export async function fetchStoreIntegrations(): Promise<{ items: StoreRow[] }> {
  const response = await fetch(`${API_BASE}/store-integrations`)
  if (!response.ok) throw new Error(`/store-integrations ${response.status}`)
  const body = (await response.json()) as { items: StoreApiRow[] }
  return { items: body.items.map(mapStoreRow) }
}
